var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.length === 0)?_c('div',{staticClass:"container"},[(!_vm.loading && _vm.length === 0 && !_vm.hasFilter)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.emptyMessage))])]):_vm._e(),(!_vm.loading && _vm.length === 0 && _vm.hasFilter)?_c('div',[_c('p',[_vm._v("Os filtros aplicados não geraram nenhum resultado.")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }